import { useQuery, useMutation, useQueryClient } from "react-query";
import adminApi from "../api/adminApi";

export const useAdminBloodRequestsList = (params) => {
  return useQuery(
    ["admin-blood-requests", params],
    () => adminApi.listBloodRequests(params),
    { keepPreviousData: true }
  );
};

export const useAdminBloodRequest = (id) => {
  return useQuery(
    ["admin-blood-request", id],
    () => adminApi.getBloodRequest(id),
    { enabled: !!id }
  );
};

export const useUpdateBloodRequest = () => {
  const qc = useQueryClient();
  return useMutation(
    ({ id, data }) => adminApi.updateBloodRequest(id, data),
    {
      onSuccess: () => {
        qc.invalidateQueries("admin-blood-requests");
      },
    }
  );
};

export const useDeleteBloodRequest = () => {
  const qc = useQueryClient();
  return useMutation((id) => adminApi.deleteBloodRequest(id), {
    onSuccess: () => {
      qc.invalidateQueries("admin-blood-requests");
    },
  });
};
